import { MainContentZone, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Content from '../../_Content';
import Constants from '../../../Constants';
import { News } from '../../../interfaces/News';
import { NewsResourceInfo } from '../../NewsResource/NewsResource';

import { StyledDiv, StyledLink, StyledTitle } from './Widget.styles';

export interface WidgetProps { }

const Widget: FC<WidgetProps> = () => {
  const { t } = useTranslation('Section');
  const news: News[] = useScopedSelector(NewsResourceInfo.dataDst);

  if (!news || news.length === 0) return null;
  return (
    <MainContentZone data-testid="newsSection" m-b={-60}>
      <StyledDiv>
        <StyledTitle>{t('title')}</StyledTitle>
        {news.length > 3 &&
          <StyledLink redirectTo={Constants.BasePagePath}>
            {t('newsLink')}
          </StyledLink>}
      </StyledDiv>
      <Content currentPage={1} isAllNews={false} news={news} />
    </MainContentZone>
  );
};
export default Widget;
